import { ComponentType, useCallback, useEffect, useMemo, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { Product, ProductsType, SearchProductResult } from "../types/product"
import { useServer } from "./providers/server"

const Products: ComponentType<Props> = ({ viewComponent: View, productsType }) => {
    const seatId = useParams().seatId
    const productGroupId = useParams().productGroupId
    const server = useServer()
    const navigate = useNavigate()
    const [fetched, setFetched] = useState(false)
    const [{ list, total, productGroup }, setResult] = useState<SearchProductResult>({ list: [], total: 0 })
    const fetchAsync = useCallback(async () => {
        setResult(await server.searchProducts({ page: 1, perPage: 10, productGroupId }))
    }, [productGroupId, server])
    useEffect(() => {
        fetchAsync().then(() => setFetched(true))
    }, [fetchAsync])
    const handleClick = (item: Product) => {
        if (productsType === "menu") {
            navigate(`/products/${item.id}`)
        } else {
            navigate(`/seat=${seatId}/products/${item.id}`)
        }
    }
    const title = useMemo(() => {
        if (productsType === "menu") {
            return "メニュー"
        }
        if (productGroup == null) {
            return 'テーブルオーダー'
        } else {
            return productGroup.label
        }
    }, [productGroup, productsType])
    return (
        <View
            list={list}
            total={total}
            onClick={handleClick}
            title={title}
            isReserve={productsType === 'reserve'}
            isMenu={productsType === 'menu'}
            isTableOrder={productsType === 'tableOrder'}
        />
    )
}

export default Products

interface Props {
    viewComponent: ProductsViewType
    productsType: ProductsType
}

export type ProductsViewType = ComponentType<{
    list: Product[]
    total: number
    onClick: (item: Product) => any
    title: string
    isReserve: boolean
    isTableOrder: boolean
    isMenu: boolean
}>


